import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { IconButton } from '@alfalab/core-components-icon-button/esm';
import { CrossHeavyMIcon } from '@alfalab/icons-glyph/CrossHeavyMIcon';
import { CrossMIcon } from '@alfalab/icons-glyph/CrossMIcon';

var defaultColors = {"button":"navigation-bar-private__button_9uq06","mobile":"navigation-bar-private__mobile_9uq06"};
require('./default.css')

var styles = {"closer":"navigation-bar-private__closer_1o03y","button":"navigation-bar-private__button_1o03y","sticky":"navigation-bar-private__sticky_1o03y"};
require('./index.css')

var invertedColors = {"button":"navigation-bar-private__button_1cpwn","mobile":"navigation-bar-private__mobile_1cpwn"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var Closer = function (_a) {
    var _b, _c;
    var view = _a.view, className = _a.className, sticky = _a.sticky, _d = _a.icon, icon = _d === void 0 ? view === 'desktop' ? CrossHeavyMIcon : CrossMIcon : _d, _e = _a.colors, colors = _e === void 0 ? 'default' : _e, dataTestId = _a.dataTestId, onClose = _a.onClose, restProps = __rest(_a, ["view", "className", "sticky", "icon", "colors", "dataTestId", "onClose"]);
    var handleClick = function (event) {
        onClose === null || onClose === void 0 ? void 0 : onClose(event, 'closerClick');
    };
    return (React.createElement("div", { className: cn(styles.closer, className, (_b = {},
            _b[styles.sticky] = sticky,
            _b)) },
        React.createElement(IconButton, __assign({ size: view === 'desktop' ? 's' : 'xs', className: cn(styles.button, colorStyles[colors].button, (_c = {},
                _c[colorStyles[colors].mobile] = view === 'mobile',
                _c)), "aria-label": '\u0437\u0430\u043A\u0440\u044B\u0442\u044C', onClick: handleClick, icon: icon, colors: colors, dataTestId: dataTestId }, restProps))));
};

export { Closer };
